import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.707 3.293a1 1 0 0 1 .23 1.058l-3 8a1 1 0 1 1-1.873-.702l2.227-5.94-10.933 4.1 4.885 1.22a1 1 0 0 1 .727.729l1.221 4.884.373-.993a1 1 0 1 1 1.872.702l-1.5 4a1 1 0 0 1-1.906-.108l-1.855-7.418-7.418-1.855a1 1 0 0 1-.108-1.906l16-6a1 1 0 0 1 1.058.229",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_locate-Jnxd3mDL.js.map
